// Firebase configuration for NOM-035 app
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDV5IcxUAw0aqU_gKobGzIZPdenysyQVvE",
  authDomain: "perspicaz-nom035.firebaseapp.com",
  projectId: "perspicaz-nom035",
  storageBucket: "perspicaz-nom035.firebasestorage.app",
  messagingSenderId: "824847029388",
  appId: "1:824847029388:web:a876c97d4eb36c876317a9",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
